import { render } from "./TournamentMatch.vue?vue&type=template&id=513a0541&ts=true"
import script from "./TournamentMatch.vue?vue&type=script&lang=ts"
export * from "./TournamentMatch.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__